<template>
  <el-dialog
    title="绑定/更换设备"
    :visible.sync="dialogVisible"
    width="30%"
    ref="dialog"
    :before-close ="handleClose">
      <el-form
        ref="formData"
        class="global-form2"
        :model="info"
        label-position="right"
        label-width="80px">
        <el-form-item label="班组名称">{{info.teamName}}</el-form-item>
        <el-form-item label="所属项目">{{info.projectName}}</el-form-item>
        <el-form-item label="设备信息:"></el-form-item>
        <el-button type="primary" @click="onAdd" class="margin30">添加</el-button>
        <el-table class="global-table" stripe :data="tableData">
          <el-table-column label="设备编号" prop="deviceNumber" show-overflow-tooltip min-width="100px"></el-table-column>
          <el-table-column label="设备类型" prop="deviceType" show-overflow-tooltip>
            <template v-slot="{ row }">
              {{row.deviceType === 'S0' ? '工牌' : '手环'}}
            </template>
          </el-table-column>
          <el-table-column label="设备状态" prop="deviceStatus" show-overflow-tooltip>
            <template v-slot="{ row }">
              {{row.deviceStatus === '1' ? '在线' : row.deviceStatus === '2' ? '离线' : ''}}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60px" fixed="right">
            <template v-slot="{ row, $index }">
              <el-button type="text" @click="onDelete(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item>
          <el-button type="primary" @click="onSaveAll" :disabled='submitShow'>保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
      <el-dialog
        title="选择设备"
        :visible.sync="showDialog"
        width="20%"
        append-to-body
        :before-close ="handleClose1">
        <el-form
          ref="formData"
          :model="searchInfo"
          label-position="right"
          label-width="0px">
          <el-form-item prop="deviceNumber">
            <el-input v-model="searchInfo.deviceNumber" placeholder="请输入设备串号"></el-input>
          </el-form-item>

          <el-form-item>
            <el-table class="global-table" stripe :data="deviceList"
               @selection-change="selectTable">
              <el-table-column
                type="selection"
                width="55"
               :selectable="selectable">
            </el-table-column>
              <el-table-column label="设备编号" prop="deviceNumber" show-overflow-tooltip min-width="100px"></el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSave" :disabled='submitShow'>保存</el-button>
            <el-button @click="handleClose1">取消</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  name: 'Bind',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {
          deviceId: ''
        }
      }
    }
  },
  data () {
    return {
      deviceList: [],
      submitShow: false,
      showDialog: false,
      tableData: [],
      searchInfo: {
        deviceNumber: '',
        teamId: ''
      },
      checkedNumber: []
    }
  },
  watch: {
    dialogVisible (val) {
      // val && this.getDeviceList()
    },
    info (val) {
      this.getDetail()
      this.getDeviceList()
      // this.tableData = JSON.parse(JSON.stringify(val))
    },
    'searchInfo.deviceNumber' (val) {
      if (val) {
        this.deviceList = this._deviceList.filter(item => item.deviceNumber.indexOf(val) !== -1)
      } else {
        this.deviceList = this._deviceList
      }
    }
  },

  created () {
  },
  methods: {
    handleClose () {
      this.$emit('update:dialogVisible', false)
      this.$emit('success')
    },
    handleClose1 () {
      this.searchInfo.deviceNumber = ''
      this.checkedNumber = []
      this.showDialog = false
    },
    onDelete (row, index) {
      this.tableData.splice(index, 1)
    },
    selectTable (row) {
      this.checkedNumber = row
    },
    onAdd () {
      this.showDialog = true
    },
    getDetail () {
      this.$axios.get(this.$apis.laborManage.selectYhTeamByTeamIdJg, {
        teamId: this.info.teamId
      }).then(res => {
        this.tableData = res.deviceList || []
      })
    },
    getDeviceList () {
      this.$axios.get(this.$apis.laborManage.selectYhDeviceByList, {
        projectId: this.info.projectId
      }).then(res => {
        this.deviceList = res || []
        this._deviceList = res || []
      })
    },
    onSave () {
      if (this.checkedNumber.length === 0) {
        this.$message.warning('设备编号不能为空')
        return
      }
      this.tableData = [...this.tableData, ...this.checkedNumber]
      this.handleClose1()
    },
    onSaveAll () {
      this.submitShow = true
      this.$axios.post(this.$apis.laborManage.updateYhTeamJg, {
        deviceNumberList: this.tableData.map(item => item.deviceNumber),
        teamId: this.info.teamId,
        projectId: this.info.projectId
      }).then(() => {
        this.$message.success('保存成功')
        this.handleClose()
        this.getDetail()
        this.$emit('success')
      }).finally(() => {
        this.submitShow = false
      })
    },
    selectable (row, rowIndex) {
      const index = this.tableData.findIndex(item => item.deviceNumber === row.deviceNumber)
      console.log(index)
      if (index !== -1) {
        return false
      } else {
        return true
      }
    }
  }

}
</script>

<style scoped lang="scss">
.margin30{
  margin-left: 10px;
}
</style>
